import angular from 'angular';
import uiRouter from 'angular-ui-router';
import sessionNotificationComponent from './session-notification.component';

let sessionNotificationModule = angular.module('session-notification', [uiRouter])

.component('sessionNotification', sessionNotificationComponent)

.name;

export default sessionNotificationModule;



// WEBPACK FOOTER //
// ./client/app/common/session-notification/session-notification.js